// @ts-nocheck

import { GridsActionTypes } from '../types/actions';
import type { SetTutoStepType, SetPoolNavigationType, SetActivePoolsType, SetRunningGridsType } from '../types/actions';

export const setTutoStep: SetTutoStepType = (step) => ({
  type: GridsActionTypes.SET_TUTO_STEP,
  payload: { step },
});

export const setPoolNavigationType: SetPoolNavigationType = (type) => ({
  type: GridsActionTypes.SET_POOL_NAVIGATION,
  payload: {
    type,
  },
});

export const setActivePools: SetActivePoolsType = (activePools) => ({
  type: GridsActionTypes.SET_ACTIVE_POOLS,
  payload: {
    activePools,
  },
});

export const setRunningGrids: SetRunningGridsType = (runningGrids) => ({
  type: GridsActionTypes.SET_RUNNING_GRIDS,
  payload: {
    runningGrids,
  },
});
